import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- Auto-refresh the access token on 401 responses -------------------
// The backend access_token cookie expires after 30 min, but a longer-lived
// refresh_token cookie (7 days) exists via POST /auth/refresh. Without this
// interceptor, every request made after 30 min of activity would fail with
// an unhandled 401 rejection (crashing pages that don't wrap calls in
// try/catch). We refresh once and retry the original request transparently.
let isRefreshing = false;
let pendingQueue = [];
let onSessionExpired = () => {};

export function setSessionExpiredHandler(handler) {
  onSessionExpired = handler;
}

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const isAuthEndpoint = config?.url?.includes("/auth/login") || config?.url?.includes("/auth/refresh");
    if (!response || response.status !== 401 || config._retried || isAuthEndpoint) {
      return Promise.reject(error);
    }
    config._retried = true;

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        pendingQueue.push({ resolve, reject, config });
      });
    }

    isRefreshing = true;
    try {
          await client.post("/auth/refresh");
          isRefreshing = false;
          pendingQueue.forEach(({ resolve, reject, config: queuedConfig }) => {
            client(queuedConfig).then(resolve).catch(reject);
          });
          pendingQueue = [];
          return client(config);
        } catch (refreshError) {
          isRefreshing = false;
          pendingQueue.forEach(({ reject }) => reject(error));
          pendingQueue = [];
          
          // =========================================================
          // PERBAIKAN: Abaikan notifikasi jika ini adalah pengecekan 
          // awal (/auth/me) saat web baru pertama kali dibuka.
          // =========================================================
          if (!config?.url?.includes("/auth/me")) {
            onSessionExpired();
          }
          
          return Promise.reject(error);
        }
        } // <--- INI ADALAH PENUTUP YANG TADI HILANG
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
